module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Clothes/Cap-e12931b08c65926224ddc44570af70a7.svg";